/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AiRecommendationsData } from '../models/AiRecommendationsData';
import type { DHSurveyJobDefinition } from '../models/DHSurveyJobDefinition';
import type { ListJobsDataCutsResponseItem } from '../models/ListJobsDataCutsResponseItem';
import type { SurveyJobCategory } from '../models/SurveyJobCategory';
import type { SurveyJobLevelBCMappings } from '../models/SurveyJobLevelBCMappings';
import type { SurveyJobSearchField } from '../models/SurveyJobSearchField';
import type { TypeOfPay } from '../models/TypeOfPay';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class SurveyJobService {

    /**
     * get Survey Jobs from Company
     * @returns any Success
     * @throws ApiError
     */
    public static listJobsData({
        requestBody,
    }: {
        requestBody: {
            offset?: number;
            limit?: number;
            sort?: Record<string, any>;
            compositeId?: number;
            paymarketId?: number;
            planId?: number;
            vendor?: Array<string>;
            jobCategory?: Array<string>;
            careerLevel?: Array<string>;
            globalLevel?: Array<string> | null;
            jobFamily?: Array<string>;
            jobSubFamily?: Array<string>;
            survey?: Array<string>;
            effectiveDate?: Array<string>;
            industry?: Array<string>;
            location?: Array<string>;
            organizations?: number;
            incumbents?: number;
            surveyJobTitle?: number;
            recommended?: boolean;
            search?: Array<string>;
            searchFields?: Array<SurveyJobSearchField>;
            dataCuts?: string | null;
            surveyJobProfile?: Array<string>;
            companyJobId?: number;
            aiRecommendations?: boolean;
            alwaysDisplayUsed?: boolean;
        },
    }): CancelablePromise<{
        count?: number;
        rows: Array<DHSurveyJobDefinition>;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/survey/job',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * get Ai Recommendations Data for Survey Jobs
     * @returns any Success
     * @throws ApiError
     */
    public static jobsAiRecommendationsData({
        requestBody,
    }: {
        requestBody: {
            companyJobId?: number;
            surveyJobDefinitionIds?: Array<string>;
            aiRecommendations?: boolean;
        },
    }): CancelablePromise<{
        rows: Array<AiRecommendationsData>;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/survey/job/aiRecommendationsData',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * get Survey Data Cuts from Job Definition
     * @returns any Success
     * @throws ApiError
     */
    public static listJobsDataCuts({
        id,
        requestBody,
    }: {
        /**
         * Survey Job Definition ID
         */
        id: string,
        requestBody: {
            /**
             * Currency ID
             */
            currencyId?: number;
            /**
             * Mapped Paymarket ID
             */
            mappedPaymarketId?: number;
            /**
             * Mapped Plan ID
             */
            mappedPlanId?: number;
            /**
             * Page number
             */
            offset?: number;
            /**
             * Max items per page
             */
            limit?: number;
            /**
             * Sort fields
             */
            sort?: Record<string, any>;
            /**
             * Survey Ids
             */
            surveyIds?: Array<string>;
            typeOfPay?: TypeOfPay;
            /**
             * Organizations filter
             */
            orgs?: number;
            /**
             * Incumbents filter
             */
            incs?: number;
            /**
             * Survey Data Cut search
             */
            search?: string;
            /**
             * Survey Id and Survey Data Ids used for pricing the composite
             */
            surveyDataIdSurveyIdList?: Array<{
                surveyId: string;
                surveyDataId: string;
            }>;
            /**
             * Survey Effective Date
             */
            effectiveDate?: string;
        },
    }): CancelablePromise<{
        rows?: Array<ListJobsDataCutsResponseItem>;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/survey/job/{id}/cuts',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get survey job levels
     * @returns SurveyJobLevelBCMappings Success
     * @throws ApiError
     */
    public static listLevels({
        vendorLevelProfileIds,
        sort,
        search,
        jobCategory,
    }: {
        /**
         * Vendor Level Profile Ids
         */
        vendorLevelProfileIds?: Array<string>,
        sort?: string,
        search?: string,
        jobCategory?: Array<string>,
    }): CancelablePromise<Array<SurveyJobLevelBCMappings>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/surveyJob/level',
            query: {
                'vendorLevelProfileIds': vendorLevelProfileIds,
                'sort': sort,
                'search': search,
                'jobCategory': jobCategory,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get list of survey job categories
     * @returns SurveyJobCategory Success
     * @throws ApiError
     */
    public static listCategories({
        vendorLevelProfileIds,
    }: {
        /**
         * Vendor Level Profile Ids
         */
        vendorLevelProfileIds?: Array<string>,
    }): CancelablePromise<Array<SurveyJobCategory>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/surveyJob/category',
            query: {
                'vendorLevelProfileIds': vendorLevelProfileIds,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get Survey Job
     * @returns DHSurveyJobDefinition Success
     * @throws ApiError
     */
    public static getSurveyJob({
        surveyJobId,
    }: {
        /**
         * Survey Job ID
         */
        surveyJobId: string,
    }): CancelablePromise<DHSurveyJobDefinition> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/surveyJob/{surveyJobId}',
            path: {
                'surveyJobId': surveyJobId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
